import { useLocation, useMatch } from "@tanstack/react-router";
import { useMemo, useRef } from "react";

const usePersonParams = () => {
  const location = useLocation();
  const initialPath = useRef(location.pathname);

  // アンマウントするときと値が変わらないようにメモ化する
  const from = useMemo(() => {
    // HACK: プロフィールから別画面に遷移する際に、ProfileHeaderのアンマウント前にlocation.pathnameが遷移先のURLに変わってしまいエラーになるため、useRefでパスを保存しておき利用している。。。
    const path = location.pathname.startsWith("/_staff/person/")
      ? location.pathname
      : initialPath.current;
    if (path.includes("alumni")) {
      return "/_staff/person/alumni/$id";
    }
    if (path.includes("family")) {
      return "/_staff/person/$id/_profile/family/$familyPersonId/";
    }
    return "/_staff/person/$id";
  }, [location.pathname]);

  return useMatch({
    from,
    select: (m) => m.params,
  });
};

export default usePersonParams;
